import React from "react"
import { View } from "@design-system/core"
import { forwardRef } from "@design-system/styled-system"
import { useTabs } from "./useTabs"
import { TabsProps } from "./types"
import { TabsProvider } from "./TabsContext"

export const Tabs = forwardRef<TabsProps, "div">((props, forwardedRef) => {
  const {
    id,
    isLazy,
    showPreviousNextButtons,
    selectedIndex,
    focusedIndex,
    setSelectedIndex,
    setFocusedIndex,
    tabRefs,
    setTabRef,
    style,
    children,
    ...htmlProps
  } = useTabs(props)

  const context = {
    id,
    isLazy,
    showPreviousNextButtons,
    selectedIndex,
    focusedIndex,
    setSelectedIndex,
    setFocusedIndex,
    tabRefs,
    setTabRef,
  }

  return (
    <TabsProvider value={context}>
      <View
        {...htmlProps}
        accessibilityRole="tabs"
        ref={forwardedRef}
        style={style}
        nativeID={id}
      >
        {children}
      </View>
    </TabsProvider>
  )
})

Tabs.displayName = "Tabs"

Tabs.defaultProps = {
  defaultIndex: 0,
}
